export * from './angularfire2';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/mac-jeremy/Projets/fairepart/~/angularfire2/index.js
// module id = ../../../../angularfire2/index.js
// module chunks = 4